<template>
	<div class="loan-info">
		<span class="loan-property-address">
			{{
				loan.subjectPropertyAddress && loan.subjectPropertyAddress.addressLine1
					? `${loan.subjectPropertyAddress.addressLine1},`
					: ''
			}}
			{{
				loan.subjectPropertyAddress && loan.subjectPropertyAddress.addressLine2
					? `${loan.subjectPropertyAddress.addressLine2},`
					: ''
			}}
			{{
				loan.subjectPropertyAddress && loan.subjectPropertyAddress.unitNumber
					? `${loan.subjectPropertyAddress.unitNumber},`
					: ''
			}}
			{{
				loan.subjectPropertyAddress && loan.subjectPropertyAddress.city
					? `${loan.subjectPropertyAddress.city},`
					: ''
			}}
			{{ loan.subjectPropertyAddress && loan.subjectPropertyAddress.state }}
			{{ loan.subjectPropertyAddress && loan.subjectPropertyAddress.zipCode }}
		</span>
		<span>
			{{
				loan.purpose && loan.purpose.purposeDesc
					? `${loan.purpose.purposeDesc}`
					: ''
			}}{{
				loan.purpose && loan.purpose.purposeDesc && loan.closingDate ? ':' : ''
			}}
			{{ getDateString(loan.closingDate) }}
		</span>
	</div>
</template>

<script>
import { getDateString } from '../helpers';

export default {
	name: 'LoanInfo',
	props: {
		loan: Object,
	},
	methods: {
		getDateString,
	},
};
</script>

<style lang="scss" scoped>
.loan-info {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;

	.loan-property-address {
		@include typo--roboto__medium;
		color: $brand-blue;
	}
}
</style>
